<template>
  <div>
    <ModalWindow
      class="apply-now-modal"
      :show="showApplyNow"
      @close="toggleApplyNow"
    >
      <div class="apply-now-content-wrapper">
        <CloseCircleIcon
          class="apply-now-close-icon"
          @click="toggleApplyNow"
        />
        <div class="first-column columns">
          <h1 class="apply-now-title">
            Sorry, this is a Proxify members only event.
            <br />
            Come join us?
          </h1>
          <p class="apply-now-description">
            Get access to tailored remote jobs, exclusive events, and more.
          </p>
          <ApplyButton
            cta-section="apply-now-modal"
            class="btn"
          />
        </div>
        <div class="second-column columns">
          <NuxtPicture
            class="user-icon"
            src="/images/events-page/events-detail/sahil_cerit.png"
            alt="user-icon"
            lazy
          />
          <p class="quote">
            "Proxify offers opportunities at companies that pay well, with
            exciting technologies. My work is challenging me to learn new
            things."
          </p>
          <p class="name">Onur Sahil Cerit</p>
          <Glassdoor />
        </div>
      </div>
    </ModalWindow>
    <ModalWindow
      class="success-modal"
      :show="showSuccess"
      @close="toggleSuccess"
    >
      <div class="success-content-wrapper">
        <CloseCircleIcon
          class="success-close-icon"
          @click="toggleSuccess"
        />
        <NuxtImg
          class="envelope-icon"
          src="/images/events-page/events-detail/rounded_envelope.svg"
          alt="envelope"
          lazy
        />
        <h1 class="success-title">
          Congrats, you're attending!
          <br />
          Check your email for an event link.
        </h1>
        <nuxt-link
          class="btn"
          to="/events"
        >
          Back to events
        </nuxt-link>
      </div>
    </ModalWindow>
  </div>
</template>

<script>
import ModalWindow from '~/components/Common/UI/ModalWindow/ModalWindow.vue';
import CloseCircleIcon from '~/components/Common/Svg/CloseIconV2.vue';
import Glassdoor from '~/components/Common/Glassdoor/Glassdoor.vue';
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: { ApplyButton, ModalWindow, CloseCircleIcon, Glassdoor },
  props: {
    toggleApplyNow: {
      type: Function,
      default: () => {},
    },
    toggleSuccess: {
      type: Function,
      default: () => {},
    },
    showApplyNow: {
      type: Boolean,
      default: false,
    },
    showSuccess: {
      type: Boolean,
      default: false,
    },
  },
  beforeUnmount() {
    document.body.style.overflow = 'auto';
  },
};
</script>

<style lang="scss" scoped>
@import './Modals.scss';
</style>
